"use server";

import { termsOfUseService } from "../services/termsOfUseService";
import { extractDomain } from "../utils/domain";

/**
 * Fetch Terms of Use page content from API
 */
export async function getTermsOfUseDataAction(
  franchiseeId?: string | null,
  language?: string | null,
) {
  try {
    const domain = await extractDomain();

    const data = await termsOfUseService.fetchByDomain(domain, franchiseeId, language);

    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error("[getTermsOfUseDataAction] Error:", error);
    return {
      success: false,
      data: null,
    };
  }
}
